/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

'use strict';

// public
module.exports = require('spa-component-scrollbar');

// correct component name
module.exports.prototype.name = 'stb-component-scrollbar';
